class LandingProductSection extends HTMLElement {
  constructor() {
    super()
    this.productBlocks = this.querySelectorAll('.products-list__product')
    this.addButton = this.querySelector('.products-list__product__button')
    this.clickedBlock = null
    this.isProductVisible = false

    this.clearCart()
    this.productBlocks.forEach(block => {
      block.addEventListener('click', () => {
        this.clickedBlock = block
        this.highlightBlock()      
      })
    })
    this.addButton.addEventListener('click', this.clearCartAndAddToCart.bind(this))
  }

  clearCart() {
    return fetch('/cart/clear.js')
  }

  clearCartAndAddToCart(event) {
    event.preventDefault()
    event.stopPropagation()
    this.clearCart()
      .then(() => {
        this.addToCart()
      })
  }

  highlightBlock() {
    this.querySelector('.products-list__product--active').classList.remove('products-list__product--active')
    this.clickedBlock.classList.add('products-list__product--active')
    this.changeButtonPrice(this.clickedBlock)
  }

  changeButtonPrice(product) {
    let fullPrice = Number(product.dataset.fullPrice) * Number(product.dataset.quantity)
    this.querySelector('.products-list__product__button span').innerHTML = `$${
        fullPrice % 1 > 0 ? fullPrice.toFixed(2) : Math.floor(fullPrice)
    }`
  }

  addToCart() {
    let object = JSON.parse(this.querySelector('#landing-product__object').innerHTML).settings
    let activeProduct = this.querySelector('.products-list__product--active')
    let productId = activeProduct.dataset.id
    let products = object.products
    let variantId
    let currentProduct
    let currentPrice = +activeProduct.querySelector('[data-current-price]')?.dataset.currentPrice?.replace('$','')
    let regularPrice = +activeProduct.querySelector('[data-regular-price]')?.dataset.regularPrice?.replace('$','')
    let discounts = JSON.parse(window.collagenDiscounts.replace(',}', '}'))
    let discount_code = null
    if (discounts[`${productId}-${activeProduct.dataset.quantity}`] != '') {
      discount_code = discounts[`${productId}-${activeProduct.dataset.quantity}`]
    }
    for (let product = 0; product < object.products.length; product++) {
      if (products[product].id == productId) {
        currentProduct = products[product]
        for (let i = 0; i < currentProduct.variants.length; i++) {
          if (currentProduct.variants[i].title == 'Default Title') {
            variantId = currentProduct.variants[i].id
            break
          }
        }
      }
    }
    let atcObject = {
      'items': [{
        'id': Number(variantId),
        'quantity': Number(activeProduct.dataset.quantity)
      }]
    };
    if (window.landing_uniq_prop != '') {
      atcObject.items[0].properties = {
        _landingSubscription: window.landing_uniq_prop
      }
    }
    if(localStorage.getItem('first-visited-page')){
      atcObject.items[0].properties = atcObject.items[0].properties || {};
      atcObject.items[0].properties['_first_visited_page'] = localStorage.getItem('first-visited-page');
    }

    window.klaviyoItem = {
      Name: currentProduct.title,
      ProductID: currentProduct.id,
      Categories: currentProduct.title,
      ImageURL: currentProduct.featured_image,
      URL: `${window.location.origin}/products/${currentProduct.handle}`,
      Brand: currentProduct.vendor,
      Price: window.theme.moneyFormat?.replace('{{amount}}', currentPrice.toFixed(2)),
      CompareAtPrice: window.theme.moneyFormat?.replace('{{amount}}', regularPrice.toFixed(2))
    }

    klaviyo.push(['track', 'Added to Cart', klaviyoItem]);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(atcObject)
    })
    .then(() => {
      window.location.href = discount_code ? `/checkout?discount=${discount_code}` : '/checkout'
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

}

customElements.define('landing-product', LandingProductSection);